import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getWarehouses, loaderState } from '../../../actions';
import { initilizeDataTable, destroyDataTable, warehousesData } from '../../../helpers';
import AddDisAssembliesComp from '../../../components/production/addDisAssembly';

class AddDisAssemblies extends Component {
	componentDidMount() {
		const { warehouses } = this.props;
		if (warehouses.length === 0) {
			this.props.loaderState(true);
			this.props.getWarehouses();
		}
		initilizeDataTable('disassembies-table');
	}

	componentDidUpdate() {
		initilizeDataTable('disassembies-table');
	}

	render() {
		destroyDataTable('disassembies-table');
		const { warehouses } = this.props;
		return <AddDisAssembliesComp warehouses={warehousesData(warehouses)} />;
	}
}

const mapStateToProps = state => {
	return {
		warehouses: state.system.warehouses.allWarehouses,
	};
};

export default connect(mapStateToProps, { loaderState, getWarehouses })(AddDisAssemblies);
